import React from "react";
import { CommonButton } from "../../Input";

const Step5Success = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center w-100"
      style={{ minHeight: "50vh" }}
    >
      <div className="text-center w-100 p-5 mt-5">
        <div className="mb-4">
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.3335 34.6667L28.0002 45.3333L54.6668 18.6667"
              stroke="#00D26A"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.3335 48L28.0002 58.6667L54.6668 32"
              stroke="#00D26A"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        
        <h4 className="fw-bold mb-3" style={{ color: "#00D26A", fontSize: "20px" }}>
          Transaction Successful!
        </h4>
        
        <p className="text-secondary mb-4 fs-14">
          Your transaction has been completed successfully. You can download, print, or email the receipt.
        </p>
        
        <div className="d-flex justify-content-center align-items-center gap-3 mt-4 flex-wrap">
          <CommonButton
            variant="outline"
            className="px-4 py-2 border-light fw-bold text-black bg-white"
            style={{ fontSize: "13px", height: "auto" }}
          >
            <i className="fa fa-download me-2"></i>
            Download receipt
          </CommonButton>
          <CommonButton
            variant="outline"
            className="px-4 py-2 border-light fw-bold text-black bg-white"
            style={{ fontSize: "13px", height: "auto" }}
          >
            <i className="fa fa-print me-2"></i>
            Print receipt
          </CommonButton>
          <CommonButton
            variant="outline"
            className="px-4 py-2 border-light fw-bold text-black bg-white"
            style={{ fontSize: "13px", height: "auto" }}
          >
            <i className="far fa-envelope me-2"></i>
            Email receipt
          </CommonButton>
        </div>
      </div>
    </div>
  );
};

export default Step5Success;
